import { MaterialTransferido } from "@/shared/interfaces";
import { PaginationState } from "@tanstack/react-table";
import { create } from "zustand";

type productosEliminadosProps = {
  productos: MaterialTransferido[],
  pagination: PaginationState
  paginatedData: MaterialTransferido[],
  handleCargarProductos: (producto: MaterialTransferido[]) => void;

  clearSelectedItems: () => void;

  setPagination: (pagination: PaginationState | ((prev: PaginationState) => PaginationState)) => void
}
export const useProductosEliminados = create<productosEliminadosProps>((set) => ({
  productos: [],
  pagination: { pageIndex: 0, pageSize: 10 },
  paginatedData: [],

  clearSelectedItems() {
    set(() => {
      return {
        pagination: { pageIndex: 0, pageSize: 10 },
        productos: []
      }
    })
  },
  setPagination: (pagination) => {
    set((state) => {
      const newPagination = typeof pagination === "function"
        ? pagination(state.pagination)
        : pagination;
      return {
        pagination: newPagination,
        paginatedData: state.productos.slice(
          newPagination.pageIndex * newPagination.pageSize,
          (newPagination.pageIndex + 1) * newPagination.pageSize
        ),
      };
    })

  },
  handleCargarProductos: (producto) => {
    set((state) => {
      return {
        productos: producto,
        paginatedData: producto.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        )
      }
    })
  },

}))